import {
  tidRedirectUrl$,
  updateTidRedirectUrl,
} from '../../repositories/auth.repository';
import { SafePipe } from '../../pipes/safe.pipe';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'tmx-logout',
  standalone: true,
  imports: [SafePipe],
  template: `<iframe hidden [src]="url() | safe" (load)="onLoad()"></iframe>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent {
  loadCounter = 0;
  url = toSignal(tidRedirectUrl$, {
    initialValue: '',
  });

  onLoad() {
    this.loadCounter += 1;
    if (this.loadCounter >= 2) {
      updateTidRedirectUrl('');
      this.loadCounter = 0;
    }
  }
}
